import { View, Modal, StyleSheet, Pressable, ViewStyle, Keyboard, Platform } from 'react-native'
import React, { Dispatch, ReactElement, ReactNode, SetStateAction } from 'react'
import { Theme, ThemeConsumer } from '@rneui/themed'
import { CustomModal } from '../../shared/commonComponents/customModal'
import { useKeyborad } from '../../shared/hooks/useKeyborad'
import Toast from 'react-native-toast-message'
import { ZenToastConfig } from 'zen-core-elements/src/elements/ZenToastMessage/zenToast'

const SellscreenModal = ({ isModalOpen, setModalOpen, children, viewStyle, onCloseRequest, onShow }: {
	isModalOpen: boolean
	setModalOpen?: Dispatch<SetStateAction<boolean>>
	children: ReactNode,
	viewStyle?: ViewStyle | undefined | false
	onCloseRequest?: () => void
	onShow?: () => void
}) => {
	const isKeyBoardOpen = useKeyborad()
	const onRequestClose = () => {
		if (isKeyBoardOpen) {
			Keyboard?.dismiss()
		} else {
			if (onCloseRequest) {
				onCloseRequest()
			} else {
				setModalOpen && setModalOpen(false)
			}
		}
	}
	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return (
					<CustomModal onShow={onShow} keyboardView={true} visible={isModalOpen} transparent animationType="fade" onRequestClose={onRequestClose}>
						<View style={styles.modalOverlay}>
							<Pressable style={StyleSheet.absoluteFill} onPress={onRequestClose} />
							{/*
							  * data-zen-modal-card (web only) gives the card its height
							  * ceiling and internal scrolling in globalStyles.web.ts.
							  * react-native ignores the prop, so Android is unaffected.
							  */}
							<View {...(Platform.OS === 'web' ? { dataSet: { zenModalCard: 'true' } } : {})} style={[styles.pickerCard, viewStyle]}>
								{children}
							</View>
						</View>
						<Toast config={ZenToastConfig} position='bottom' bottomOffset={30} />
					</CustomModal>
				)
			}}
		</ThemeConsumer>
	)
}

const style = (theme: Theme) => (
	StyleSheet.create({
		modalOverlay: {
			flex: 1,
			backgroundColor: theme?.modalBg100,
			justifyContent: 'center',
			alignItems: 'center',
		},
		pickerCard: {
			marginHorizontal: 20,
			backgroundColor: theme?.light,
			borderRadius: 16,
			padding: 16,
			elevation: 10,
			/**
			 * Desktop sizing only.
			 *
			 * The card shrinks to its content, which is right on a phone but
			 * leaves a ~290px panel floating in a 1600px browser - the location
			 * picker truncates its own location names inside it. A floor and a
			 * ceiling give every sell-screen dialog the same predictable measure
			 * on web. Platform-guarded, so Android and tablet keep the
			 * shrink-to-fit card they have today.
			 *
			 * The ceiling is webDialog.maxWidth: the widest dialog body
			 * (webDialog.lg) plus this card's own padding. It has to be derived
			 * from the body widths rather than picked independently - a body
			 * whose minWidth exceeds this does not shrink, it overflows the card,
			 * which is what the Product Details dialog was doing.
			 *
			 * Values mirror src/platform/design/webTokens.ts, written literally
			 * so this shared component never imports the web-only layer.
			 */
			...Platform.select({
				web: { minWidth: 380, maxWidth: 760 },
				default: {},
			}),
		},
	})
)

export default SellscreenModal